var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"source"},[_c('i',{class:("icon_source " + _vm.source)}),_vm._v("\n  数据来源："+_vm._s(_vm.isCer ? "实名认证" : _vm.source === "CONSUMER" ? "本人自填" : _vm.dataSourceName)+"\n  ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2ee6e92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Source.vue
// module id = null
// module chunks = 